import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import BoArt from './BoArt';
import { APP_STORE_URL } from '../config/site';

/**
 * Sticky nav. Below 768px the link row hides - brand and the one call to
 * action only, no hamburger. The call to action is the App Store - a button
 * in the site's own style, not Apple's badge: Apple allows one badge per
 * layout, and the hero has it. On a phone it reads "Download"; the rest of
 * its name stays for a screen reader (`.nav-cta-more`).
 */
const Navbar = () => {
  const { pathname } = useLocation();
  const prefix = pathname === '/' ? '' : '/';

  const links = [
    { href: `${prefix}#how`, label: 'How it works' },
    { href: `${prefix}#programs`, label: 'Programs' },
    { href: `${prefix}#crews`, label: 'Crews' },
    { href: `${prefix}#pricing`, label: 'Pricing' },
    { href: `${prefix}#faq`, label: 'FAQ' },
  ];

  return (
    <header className="site-nav">
      <nav className="site-nav-inner" aria-label="Main">
        <Link to="/" className="brand">
          <BoArt pose="sifu" width={30} />
          <span>Bell Club</span>
        </Link>
        <div className="site-nav-links">
          {links.map((link) => (
            <a key={link.label} href={link.href}>
              {link.label}
            </a>
          ))}
        </div>
        <a href={APP_STORE_URL} rel="noopener" className="btn btn-primary btn-small">
          <span>
            Download<span className="nav-cta-more"> on the App Store</span>
          </span>
        </a>
      </nav>
    </header>
  );
};

export default Navbar;
